import React from 'react'

import {
  Button,
  Icon,
  FacebookIcon,
  LinkedInIcon,
  XIcon,
  PinterestIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import i18n from 'Pods/Shared/I18n'

const socialUrls = {
  share: {
    facebook: '//www.facebook.com/sharer.php?u=',
    linkedin: '//www.linkedin.com/shareArticle?mini=true&url=',
    x: '//x.com/home?status=',
    pinterest: '//pinterest.com/pin/create/button/?url=',
  },
  icon: {
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    x: XIcon,
    pinterest: PinterestIcon,
  },
}

const NEW_TAB_LINK_ATTRIBUTES = { target: '_blank', rel: 'noopener noreferrer' }

const networkLabels = {
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  x: 'X',
  pinterest: 'Pinterest',
}

function returnUrl(network) {
  const params = '?utm_medium=Social%26utm_campaign=Share%26utm_source='

  return socialUrls.share[network] + window.location.href + params + network
}

function SocialNetworkRow() {
  return (
    <>
      <h5 className="share-modal__social-networks-title cgt-legacy-heading-h5">
        Share on social media
      </h5>
      <div className="share-modal__social-networks">
        {Object.keys(socialUrls.icon).map((network) => (
          <Button
            key={network}
            size="small"
            type="secondary"
            variant="only-icon"
            href={returnUrl(network)}
            linkAttributes={NEW_TAB_LINK_ATTRIBUTES}
            aria-label={i18n.t('share_modal.share_on', { ns: 'rails', network: networkLabels[network] })}
            customClass="share-modal__social-network-button"
            icon={<Icon svgComponent={socialUrls.icon[network]} />}
          />
        ))}
      </div>
    </>
  )
}

export default SocialNetworkRow
